import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, firstValueFrom, throwError } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IHarvester, IHarvesterList } from '../models/Harvester';

@Injectable()
export class HarvestService {
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:
        'Bearer ' + localStorage.getItem(environment.keys.accessToken) || '',
    }),
  };

  constructor(private http: HttpClient) {

  }

  // HttpClient API create() method => Create harvest
  create(endPoint: string, body: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + endPoint, body, this.httpOptions)
    
  }

  // HttpClient API update() method => Update harvest
  async update(endPoint: string, body: any): Promise<any> {
    return await firstValueFrom(this.http
      .put<any>(environment.apiUrl + endPoint, body, this.httpOptions))
  }

  // HttpClient API put() method => Get harvest
  get(id: string): Observable<IHarvester> {
    return this.http
      .get<any>(environment.apiUrl + 'harvester/' + id, this.httpOptions)
      .pipe(
        map((result) => result.body as IHarvester),
        retry(1),
      );
  }

  // HttpClient API get() method => Get all harvest
  getAll<T = any>(endPoint: string): Observable<T> {
    return this.http
      .get<any>(environment.apiUrl + endPoint, this.httpOptions)
      .pipe(retry(1));
  }

  listHarvesters(): Observable<IHarvesterList> {
    return this.getAll('harvester').pipe(
      map((res) => res.body as IHarvesterList)
    );
  }

  postFixedCost(body: any, season_year: string): Observable<any> {

    return this.http
      .post<any>(
        `${environment.apiUrl}fixed-cost/${season_year}`,
        body,
        this.httpOptions
      )
  }

  getFixedCost(season_year: string): Observable<any> {

    return this.http
      .get<any>(
        `${environment.apiUrl}fixed-cost/${season_year}`,
        this.httpOptions
      )
  }
}
